"use client"

import { useEffect, useMemo, useState } from "react"

const initial = {
  name: "",
  email: "",
  mobile_no: "",
  council: "SCVT",
  department_id: "",
  trade: "",
  category: "",
  quota: "",
  isTechnical: false,
  durationYears: "",
  fathers_name: "",
  mothers_name: "",
  dob: "",
  gender: "",
  blood_group: "",
  block: "",
  district: "",
  pin_code: "",
  state: "",
  correspondence_block: "",
  correspondence_district: "",
  correspondence_pincode: "",
  correspondence_state: "",
  sub_category: "",
}

export default function PublicStudentRegistration() {
  const [form, setForm] = useState(initial)
  const [departments, setDepartments] = useState([])
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState(null)
const API_URL = process.env.REACT_APP_API_URL
  useEffect(() => {
    const loadDepts = async () => {
      try {
        const res = await fetch(`${API_URL}/public/departments`)
        const json = await res.json()
        if (json.success) setDepartments(json.data || [])
        else setMessage({ type: "error", text: json.message || "Failed to load departments" })
      } catch (e) {
        setMessage({ type: "error", text: e.message })
      }
    }
    loadDepts()
  }, [])

  const selectedDept = useMemo(
    () => departments.find((d) => String(d.department_id) === String(form.department_id)),
    [departments, form.department_id],
  )
  const derivedBranch = (selectedDept?.type || "").toUpperCase() === "POLY" ? "Polytechnic" : selectedDept ? "ITI" : ""

  const onChange = (e) => {
    const { name, value, type, checked } = e.target
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }))
  }

  {console.log(`${API_URL}/public/student/register`)}

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage(null)
    try {
      const payload = {
        ...form,
        department_id: form.department_id ? String(form.department_id) : "",
      }
      const res = await fetch(`${API_URL}/public/student/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
      const json = await res.json()
      if (json.success) {
        setMessage({
          type: "success",
          text: "Application submitted successfully. Institute will review and create your login. You can pay after you receive credentials.",
        })
        setForm(initial)
      } else {
        setMessage({ type: "error", text: json.message || "Submission failed" })
      }
    } catch (err) {
      setMessage({ type: "error", text: err.message })
    } finally {
      setLoading(false)
    }
  }

  const showITIFields = derivedBranch === "ITI"
  const showPolyFields = derivedBranch === "Polytechnic"

  return (
    <main className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto p-6">
        <h1 className="text-2xl font-bold mb-2">Student Registration (Public)</h1>
        <p className="text-gray-600 mb-6">
          Fill your details below. Fee will be calculated automatically and stored by the institute.
        </p>

        {message && (
          <div
            className={`mb-4 p-3 rounded ${
              message.type === "success" ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"
            }`}
          >
            {message.text}
          </div>
        )}

        <form onSubmit={onSubmit} className="bg-white shadow rounded p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
            <input
              name="name"
              value={form.name}
              onChange={onChange}
              required
              className="w-full border rounded px-3 py-2"
              placeholder="Your full name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={onChange}
              required
              className="w-full border rounded px-3 py-2"
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
            <input
              name="mobile_no"
              value={form.mobile_no}
              onChange={onChange}
              required
              pattern="[0-9]{10}"
              className="w-full border rounded px-3 py-2"
              placeholder="10-digit mobile"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Council</label>
            <select
              name="council"
              value={form.council}
              onChange={onChange}
              required
              className="w-full border rounded px-3 py-2"
            >
              <option value="SCVT">SCVT</option>
              <option value="NCVT">NCVT</option>
            </select>
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Institute (Department)</label>
            <select
              name="department_id"
              value={form.department_id}
              onChange={onChange}
              required
              className="w-full border rounded px-3 py-2"
            >
              <option value="">Select Institute</option>
              {departments.map((d) => (
                <option key={d.department_id} value={String(d.department_id)}>
                  {d.name} ({d.code})
                </option>
              ))}
            </select>
            {derivedBranch && (
              <p className="mt-1 text-sm text-gray-600">
                Branch: <span className="font-medium">{derivedBranch}</span>
              </p>
            )}
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Trade</label>
            <input
              name="trade"
              value={form.trade}
              onChange={onChange}
              required
              className="w-full border rounded px-3 py-2"
              placeholder="Your trade"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
            <input
              name="category"
              value={form.category}
              onChange={onChange}
              className="w-full border rounded px-3 py-2"
              placeholder="General/OBC/SC/ST"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Quota</label>
            <select name="quota" value={form.quota} onChange={onChange} className="w-full border rounded px-3 py-2">
              <option value="">Select</option>
              <option value="Govt">Govt</option>
              <option value="Private">Private</option>
            </select>
          </div>

          {showITIFields && (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Technical</label>
                <input type="checkbox" name="isTechnical" checked={form.isTechnical} onChange={onChange} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Duration (Years)</label>
                <select
                  name="durationYears"
                  value={form.durationYears}
                  onChange={onChange}
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="">Select</option>
                  <option value="0.5">0.5</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
              </div>
            </>
          )}

          {/* Optional fields */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Father's Name</label>
            <input
              name="fathers_name"
              value={form.fathers_name}
              onChange={onChange}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Mother's Name</label>
            <input
              name="mothers_name"
              value={form.mothers_name}
              onChange={onChange}
              className="w-full border rounded px-3 py-2"
            />
          </div>

          {/* Address chunk */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Block</label>
            <input name="block" value={form.block} onChange={onChange} className="w-full border rounded px-3 py-2" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">District</label>
            <input
              name="district"
              value={form.district}
              onChange={onChange}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Pincode</label>
            <input
              name="pin_code"
              value={form.pin_code}
              onChange={onChange}
              className="w-full border rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
            <input name="state" value={form.state} onChange={onChange} className="w-full border rounded px-3 py-2" />
          </div>

          <div className="md:col-span-2">
            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-60"
            >
              {loading ? "Submitting..." : "Submit Application"}
            </button>
            <p className="text-xs text-gray-500 mt-2">
              Note: Password will be set by the institute later. You can login and pay once you receive credentials.
            </p>
          </div>
        </form>
      </div>
    </main>
  )
}
